let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3hBIM")).then(() => parcelRequire('6jctk'));